import * as React from "react";
import "./style.scss";

// Components
import Divider from "../../../components/Divider";
import SaveAndCancelFormButtons from "../../../components/SaveAndCancelFormButtons";

// Sections
import HotelLocationForm from "./sections/HotelLocationForm";

// Mobx
import { observer, inject } from "mobx-react";
import HotelStore from "../../../stores/HotelStore";

// Resources
import strings from "../../../resources/strings";
import HotelDataForm from "./sections/HotelDataForm";
import HotelMetaTagForm from "./sections/HotelMetaTagForm";
import HotelSocialForm from "./sections/HotelSocialForm";
import HotelColorsForm from "./sections/HotelColorsForm";
import HotelAssets from "./sections/HotelAssets";

interface IProps {
	hotelStore: HotelStore;
}

@inject("hotelStore")
@observer
export default class EditHotel extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.hotelStore.getHotel();
	};

	public render() {
		const { hotelStore } = this.props;
		return (
			<div className="editHotel">
				{!hotelStore.loading && (
					<div className="editHotelCard">
						<h1 className="editHotelTitle">
							{strings.hotel.edit.title}
						</h1>
						<HotelDataForm hotelStore={hotelStore} />
						<Divider className="divider" />
						<HotelMetaTagForm hotelStore={hotelStore} />
						<Divider className="divider" />
						<HotelLocationForm
							addressService={hotelStore.addressService}
							loading={hotelStore.addressLoading}
						/>
						<Divider className="divider" />
						<HotelSocialForm hotelStore={hotelStore} />
						<Divider className="divider" />
						{/* <HotelColorsForm hotelStore={hotelStore}/>
						<Divider className="divider" /> */}
						<HotelAssets hotelStore={hotelStore} />
						<SaveAndCancelFormButtons
							onSave={() => hotelStore.editHotel()}
						/>
					</div>
				)}
			</div>
		);
	}
}
